import { midiToFreq, pitchClass } from '@/lib/pitch';

export const QUALITIES = {
  maj: { label: '', name: 'Maggiore', short: 'Magg', iv: [0, 4, 7] },
  min: { label: 'm', name: 'Minore', short: 'm', iv: [0, 3, 7] },
  7: { label: '7', name: 'Settima', short: '7', iv: [0, 4, 7, 10] },
  maj7: { label: 'maj7', name: 'Maj7', short: 'maj7', iv: [0, 4, 7, 11] },
  m7: { label: 'm7', name: 'm7', short: 'm7', iv: [0, 3, 7, 10] },
  sus4: { label: 'sus4', name: 'Sus4', short: 'sus4', iv: [0, 5, 7] },
  dim: { label: 'dim', name: 'Dim', short: 'dim', iv: [0, 3, 6] },
};

const JUST = [1, 16 / 15, 9 / 8, 6 / 5, 5 / 4, 4 / 3, 45 / 32, 3 / 2, 8 / 5, 5 / 3, 9 / 5, 15 / 8];

// Steps as [semitones from the key, quality, bars].
export const PRESETS = [
  { id: 'pop', label: 'I – V – vi – IV (pop)', steps: [[0, 'maj', 1], [7, 'maj', 1], [9, 'min', 1], [5, 'maj', 1]] },
  { id: 'fifties', label: "I – vi – IV – V (anni '50)", steps: [[0, 'maj', 1], [9, 'min', 1], [5, 'maj', 1], [7, 'maj', 1]] },
  { id: 'jazz', label: 'ii – V – I (jazz)', steps: [[2, 'm7', 1], [7, '7', 1], [0, 'maj7', 2]] },
  { id: 'blues', label: 'Blues 12 battute', steps: [[0, '7', 4], [5, '7', 2], [0, '7', 2], [7, '7', 1], [5, '7', 1], [0, '7', 1], [7, '7', 1]] },
  { id: 'andalusian', label: 'Cadenza andalusa', steps: [[0, 'min', 1], [10, 'maj', 1], [8, 'maj', 1], [7, 'maj', 1]] },
  { id: 'canon', label: 'Canone (Pachelbel)', steps: [[0, 'maj', 1], [7, 'maj', 1], [9, 'min', 1], [4, 'min', 1], [5, 'maj', 1], [0, 'maj', 1], [5, 'maj', 1], [7, 'maj', 1]] },
];

export const presetSteps = (preset, keyPc) => preset.steps.map(([o, quality, bars]) => ({ pc: (keyPc + o) % 12, quality, bars }));

// Instrument key for the drone page: written = concert + semitones.
export const DRONE_KEYS = [
  { id: 'C', label: 'C', semitones: 0, flats: false },
  { id: 'Bb', label: 'B♭', semitones: 2, flats: true },
  { id: 'Eb', label: 'E♭', semitones: 9, flats: true },
  { id: 'F', label: 'F', semitones: 7, flats: true },
];
export const droneKey = (id) => DRONE_KEYS.find((k) => k.id === id) || DRONE_KEYS[0];

export const DEFAULT_PROG = { enabled: false, keyPc: 0, steps: presetSteps(PRESETS[0], 0) };

// Moves the whole sequence to a new key, keeping the chords relative to it.
export const shiftProg = (prog, keyPc) => {
  const d = keyPc - (prog.keyPc ?? 0);
  return { steps: prog.steps.map((s) => ({ ...s, pc: (((s.pc + d) % 12) + 12) % 12 })), keyPc };
};

export const chordName = (pc, quality, flats) => `${pitchClass(pc, flats)}${QUALITIES[quality]?.label ?? ''}`;

// Step playing at the given 1-based bar count (0 = not started → first step).
export function stepAt(steps, count) {
  if (count <= 0) return 0;
  const total = steps.reduce((s, st) => s + st.bars, 0);
  let pos = (count - 1) % total;
  for (let i = 0; i < steps.length; i++) {
    if (pos < steps[i].bars) return i;
    pos -= steps[i].bars;
  }
  return 0;
}

export function droneFreqs(rootMidi, voicing, quality, just, a4) {
  const root = midiToFreq(rootMidi, a4);
  const iv = voicing === 'chord' ? (QUALITIES[quality] || QUALITIES.maj).iv : voicing === 'fifth' ? [0, 7] : [0];
  return iv.map((s) => (s === 0 ? root : just ? root * JUST[s] : midiToFreq(rootMidi + s, a4)));
}
